module.exports = __webpack_public_path__ + "img/pass.2a96ab16.svg";